<p-dialog
  [(visible)]="config.visible"
  [modal]="true"
  [closable]="config.closable"
  [dismissableMask]="config.dismissable"
  [style]="{ width: dialogWidth }"
  [styleClass]="'app-popup app-popup--' + config.type"
  (onHide)="onHide()"
  [header]="config.title"
>
  <div class="popup-body">
    <!-- Icon + message on one row -->
    <div class="popup-head" *ngIf="config.icon || config.message">
      <i [class]="iconClass" *ngIf="config.icon"></i>

      <div class="popup-message" *ngIf="config.message" [innerHTML]="config.message"></div>
    </div>

    <!-- Custom Template -->
    <div class="popup-custom" *ngIf="config.customTemplate">
      <ng-container *ngTemplateOutlet="config.customTemplate; context: { $implicit: config.data }"></ng-container>
    </div>
  </div>

  <!-- Footer Buttons -->
  <ng-template pTemplate="footer">
    <div class="popup-footer" [class.popup-footer--spread]="spreadFooter" [class.popup-footer--center]="centerFooter" *ngIf="config.buttons && config.buttons.length > 0">
      <p-button
        *ngFor="let button of config.buttons; let i = index"
        [label]="button.label"
        [severity]="button.severity || 'secondary'"
        [outlined]="button.outlined"
        [loading]="loading[i]"
        (onClick)="handleButtonClick(button, i)"
      />
    </div>
  </ng-template>
</p-dialog>
